/**
 * SuperAdmin feature flags — /superadmin/features (route shell).
 *
 * Screen impl in `./features-screen.tsx`, lazy-loaded. Platform-operator-only
 * surface (behind the /superadmin layout gate) — never on a trustee's path, so
 * it stays out of the initial bundle.
 *
 * Spec reference: docs-vault/ux/...top-level-routes.md §3.1
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/features')({
  component: lazyRouteComponent(() => import('./features-screen'), 'FeatureFlagsPage'),
});
